import React, { useEffect, useState } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import Form from '../../Reusable/Form/Form';
import { config } from './MunicipalityConfig';
import withTranslations from '../../../utils/HighOrderComponent';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dot from 'dot-object';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { findAllPlace, clearPlaceList } from '../../../actions/place';
import { findAllMunicipalityFilterPageable } from '../../../actions/municipality';

const MunicipalityFilter = ({
  t,
  findAllMunicipalityFilterPageable,
  saveFilters,
  initialValues,
  initialStateValues,
  savePostData,
  setResetData,
  municipalityList,
  placeList,
  findAllPlace,
  pageSize,
  clearPlaceList,
}) => {
  const [activeKey, setActiveKey] = useState('-1');

  useEffect(() => {
    activeKey === '0' && findAllPlace();
    return clearPlaceList();
  }, [findAllPlace, clearPlaceList, activeKey]);

  const { AccordionForm } = t || {};

  const municipalityNameList =
    municipalityList?.map((municipality) => municipality.name) || [];
  const placeNameList = placeList?.map((place) => place.name) || [];

  const { fields } = config(t, municipalityNameList, placeNameList);
  const decoratedOnClick = useAccordionToggle('0', () => {
    setActiveKey('-1');
  });

  const handleSubmit = (values) => {
    const dotNotationObj = dot.dot(values);
    const postData = {
      tableName: 'municipality',
      filterCriteria: Object.entries(dotNotationObj)
        .map((entry) => {
          if (entry[0] === 'createdAtFrom' || entry[0] === 'createdAtTo') {
            if (
              values.createdAtFrom !== initialValues.createdAtFrom ||
              values.createdAtTo !== initialValues.createdAtTo
            )
              return {
                columnName: 'createdAt',
                dateMin: values.createdAtFrom,
                dateMax: values.createdAtTo,
                logicalOperator: '><',
              };
          } else if (entry[0] === 'place.name') {
            return (
              entry[1] && {
                columnName: 'place.name',
                columnValue: entry[1],
              }
            );
          } else {
            return (
              entry[1] && {
                columnName: entry[0],
                columnValue: entry[1],
              }
            );
          }
          return null;
        })
        .filter((item) => !!item),
    };
    if (postData.filterCriteria?.length === 0) {
      resetFilters();
    } else {
      savePostData(postData);
      findAllMunicipalityFilterPageable(postData, pageSize, () =>
        saveFilters(values)
      );
    }
  };

  const packConfig = () => {
    return {
      fields: [...fields],
    };
  };

  const packTranslations = () => {
    return {
      ...t,
    };
  };

  const resetFilters = () => {
    savePostData(null);
    setResetData(true);
    return saveFilters(initialStateValues);
  };
  const filterCardStyle =
    activeKey === '0' ? 'form-row card-header-open' : 'form-row';
  return (
    <div className="Filters m-auto">
      <Accordion activeKey={activeKey}>
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            variant="link"
            eventKey="0"
            className={filterCardStyle}
            onClick={() => {
              if (activeKey !== '0') {
                setActiveKey('0');
              } else {
                setActiveKey('-1');
              }
            }}
          >
            <div className="float-left col-md-11">{AccordionForm.title}</div>
            {activeKey === '0' && initialValues !== initialStateValues && (
              <div className="col-md-1 float-right">
                <Button
                  variant="warning"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  {AccordionForm.reset}
                </Button>
              </div>
            )}
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body style={{ paddingTop: '-2vh' }}>
              <Form
                className={'PlaceForm'}
                onSubmit={handleSubmit}
                initialValues={initialValues}
                formConfig={packConfig()}
                translations={packTranslations()}
                removeCancel={true}
                submitLabel={AccordionForm.filter}
                decoratedOnClick={decoratedOnClick}
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loggedUser: state.loggedUser?.loggedUser,
  placeList: state.place.placeList || [],
  municipalityList: state.municipality.municipalityList || [],
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllMunicipalityFilterPageable: (
      postData,
      pageSize,
      successCallback
    ) => {
      dispatch(
        findAllMunicipalityFilterPageable(
          0,
          pageSize,
          postData,
          successCallback
        )
      );
    },
    findAllPlace: () => {
      dispatch(findAllPlace());
    },
    clearPlaceList: () => {
      dispatch(clearPlaceList());
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslations(MunicipalityFilter, 'MunicipalityFilter'))
);
